module.exports = __webpack_public_path__ + "static/media/LK_White_Report.66824404.svg";